import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=a41e0c22&scoped=true&lang=pug&"
import script from "./notice-detail.vue?vue&type=script&lang=js&"
export * from "./notice-detail.vue?vue&type=script&lang=js&"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=a41e0c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41e0c22",
  null
  
)

export default component.exports